/**
 * @todo add support for reCaptcha v3
 * https://developers.google.com/recaptcha/docs/v3
 */
(function($) {
  "use strict";

  const forms = {
    dom: function() {
      this.$formLink = $('[target="ajax"]');
      this.dynamicModal = $("#dynamicModal").html();
      this.$datePicker = $('[data-js-hook="pickadate"], input.datepicker');
      this.$checkbox = $('input[data-checkbox][type="checkbox"]');
      this.$clearInput = $("[data-input-clear]");

      this.file = {
        $toggle: $('[data-toggle="file"]'),
        $preview: $('[data-file="preview"]'),
      };

      this.forms = {
        contact: $("#contact-form"),
        apply: $("#jobForm"),
      };

      this.$download = $("#download");
    },

    settings: {
      activeFile: null,
      applyCheckboxMessage: '<p id="PickStatementWarning" style="display: block; margin-top: .5em; color: var(--danger);"><small>Please select two of the three statements.</small></p>'
    },

    redirectForm:
      '<form data-form="" class="redirect-form" action="/thank-you/" method="POST">' +
      '<input type="hidden" name="jonah_submit" value="1" />' +
      '<input type="hidden" name="id" value="" />' +
      '<input type="hidden" name="ip_address" value="" />' +
      '<input type="hidden" name="page" value="" />' +
      '<input type="hidden" name="referer" value="" />' +
      '<input type="hidden" name="referer_info" value="" />' +
      "</form>",

    checkbox: function() {
      const $checkboxes = $('input[data-checkbox][type="checkbox"]');

      if ($checkboxes.length) {
        $checkboxes.each(function() {
          const $fakeCheckbox = $(
            '[data-checkbox="' + $(this).data("checkbox") + '"]:not(input)',
          );

          $(this).on("change", function() {
            if ($(this).prop("checked")) {
              $fakeCheckbox.addClass("form__checkbox-fake--checked");
            }
            else {
              $fakeCheckbox.removeClass("form__checkbox-fake--checked");
            }
          });
        });
      }
    },

    clearInputs: function() {
      this.$clearInput.click(function(event) {
        event.preventDefault();
        const input = $(this).data("input-clear");
        $("#" + input)
          .val("")
          .trigger("keyup")
          .blur();
      });
    },

    datePicker: function() {
      const _ = this;
      if (this.$datePicker.length) {
        this.$datePicker.each(function() {
          const $this = $(this);
          const $label = $('label[for="' + $this.attr("id") + '"]');
          $this
            .on("mousedown", function(e) {
              e.preventDefault();
            })
            .pickadate({
              format: "mmm d, yyyy",
              disable: [
                {
                  from: [0, 0, 0],
                  to: new Date(new Date().valueOf() - 1000 * 60 * 60 * 24),
                },
              ],
              onSet: function(context) {
                if (typeof context.select != "undefined") {
                  $label.addClass("active");
                }
                else {
                  $label.removeClass("active");
                }
              },
              onRender: function() {
                _.$datePicker.removeAttr("aria-expanded");
                $($(this)[0].$root[0])
                  .find("[aria-activedescendant]")
                  .removeAttr("aria-activedescendant");
              },
              onOpen: function() {
                $label.addClass("focus");
              },
              onClose: function() {
                this.$holder.blur();
                $label.removeClass("focus");
              },
            });
        });
      }
    },

    fileTrigger: function() {
      this.file.$toggle.click(function(event) {
        event.preventDefault();
        const $target = $($(this).data("target"));
        if ($target.length) {
          $target.trigger("click");
          forms.settings.activeFile = $target;
          forms.filePreview(true);
        }
      });
    },

    filePreview: function($bAfterTrigger) {
      if ($bAfterTrigger) {
        forms.settings.activeFile.change(function() {
          const id = forms.settings.activeFile.attr("id");
          const filename = $(this)
            .val()
            .split(/(\\|\/)/g)
            .pop();
          forms.file.$preview
            .filter('[data-target="#' + id + '"]')
            .html(filename)
            .slideDown(100);
        });
      }
      else {
        $('input[type="file"]').each(function(index, element) {
          const $this = $(element);
          if ($this.val()) {
            const id = $this.attr("id");
            const filename = $this
              .val()
              .split(/(\\|\/)/g)
              .pop();
            forms.file.$preview
              .filter('[data-target="#' + id + '"]')
              .html(filename)
              .slideDown(100);
          }
        });
      }
    },

    infieldLabels: function() {
      const _ = this;
      const $infieldLabels = $("[data-infield-label]");
      if (typeof $infieldLabels != "undefined" && $infieldLabels.length) {
        $infieldLabels.each(function() {
          let $self = $(this);
          let target = $(this).attr("for");
          let $input = $("#" + target);

          if ($input.val().length) {
            $self.addClass("active");
          }

          $input.on("focus", function() {
            if (!$(this).val()) {
              $self.addClass("focus");
            }
          });

          $input.on("keyup input", function() {
            if ($(this).val()) {
              if ($(this).val().length === 1) {
                _.trimField($(this));
              }
              $self.removeClass("focus");
              $self.addClass("active");
            }
            else {
              $self.removeClass("active");
              $self.addClass("focus");
            }
          });

          $input.on("blur", function() {
            if (!$(this).val()) {
              $self.removeClass("focus");
            }
          });
        });
      }
    },

    trimField: function(field) {
      const _ = this;
      field.val($.trim(field.val()));
    },

    formModalTimeout: function(form) {
      // close modal
      const $modal = $(form).closest(".modal");
      if ($modal.length) {
        const $timeout = $modal.find('[data-js-hook="success-timeout"]');
        const $number = $timeout.find("[data-success-timeout-number]");
        if ($timeout.length && $number.length) {
          $timeout.show();

          let start = 1;
          const end = jcms.form_settings.timeout;
          let display = end;

          const countdown = setInterval(function() {
            if (start <= end) {
              --display;
              $number.text(display);
              ++start;
            }
            else {
              clearInterval(countdown);
              $timeout.hide();
            }
          }, 1000);

          setTimeout(function() {
            $modal.find('[data-dismiss="modal"]').first().trigger("click");
          }, jcms.form_settings.timeout * 1000);
        }
      }
    },

    downloadForm: function() {
      this.$download.on("submit", function() {
        const id = $(this).data("download");
        event_tracker("Form Submission", "form_success", "download_" + id);
      });
    },

    formValidation: function() {
      const requiredFields = {
        contact: "First_Name, Last_Name, Email{email}, Company_Name, Message",
        apply:
          "Position, First_Name, Last_Name, Email{email}, Location, Resume{file}, LongOrShortTerm, CharacterTraits, HearAboutUs, Pick_Statements{2}",
      };

      $.each(this.forms, function(key, form) {
        const id = form.attr("id");
        const form_name = key;
        var checkboxes = $("input[name='Pick_Statements[]']", form);
        form.formulate({
          id: id,
          require: requiredFields[key],
          errorClass: "error",
          errorParent: true,
          showOnSubmit: '[data-js-hook="' + id + '-confirm"]',
          inlineMsg: true,
          inlineMsgClass: "form__inline-error",
          fireOnSubmit: function(data, form, settings) {

            $(".form__message", $(form)).remove();

            if (key === "apply") {
              var checkboxes = $("input[name='Pick_Statements[]']", form);
              var checkedCount = checkboxes.filter(":checked").length;
              var passValidation = true;

              checkboxes
                .closest(".form__section")
                .find("#PickStatementWarning")
                .remove();

              if (checkedCount !== 2) {
                checkboxes
                  .closest(".form__section")
                  .append(forms.settings.applyCheckboxMessage);
              }
              else {
                checkboxes
                  .closest(".form__section")
                  .find("#PickStatementWarning")
                  .remove();
              }

              var jobHearAboutUs = $("#jobHearAboutUs");
              var otherOptionWrap = $("#otherOptionWrap");
              var jobHearAboutUsOther = $("#jobHearAboutUsOther");
              var otherOptionSelect = $("#otherOptionSelect");

              if (jobHearAboutUs.val() === "other") {
                otherOptionWrap.show();
                jobHearAboutUsOther.focus();
                if (!jobHearAboutUsOther.val().length) {
                  otherOptionWrap.addClass("error");
                  passValidation = false;
                }
                else {
                  otherOptionWrap.removeClass("error");
                }
              }
              else {
                otherOptionWrap.removeClass("error");
                otherOptionWrap.hide();
              }
              if (!passValidation) {
                return false;
              }

            }
          },

          fireOnSuccess: function(data, form, settings) {
            if (typeof JonahTracking !== "undefined") {
              JonahTracking.event.formSubmit($(form).attr("id"));
            }
            event_tracker("Form Submission", "form_success", form_name);
            if (typeof cmg_google_conversion !== "undefined") {
              cmg_google_conversion(
                $("#" + id.replace("-", "_") + "_conversion").val(),
                $("#" + id.replace("-", "_") + "_conversion_id").val(),
                $("#" + id.replace("-", "_") + "_conversion_html").val(),
              );
            }
            forms.formModalTimeout(form);
          },
          fireOnError: function(data, form) {
            if (data !== false) {
              let response;
              try {
                response = JSON.parse(data);
                response = response.message;
              } catch (e) {
                response = data;
              }
              const $message =
                '<p class="form__message bg-danger">' + response + "</p>";
              $(form).prepend($message);
            }
            if ($(".error :input", $(form)).length) {
              $(".error :input", $(form))[0].focus();
            }
          },
        });

        checkboxes.on("change", function() {
          var checkedCount = checkboxes.filter(":checked").length;
          var $section = checkboxes.closest(".form__section");
          $section.removeClass("error").find("#PickStatementWarning").remove();

          if (checkedCount !== 2) {
            $section.addClass("error").append(forms.settings.applyCheckboxMessage);
          }
          else {
            $section
              .removeClass("error")
              .find("#PickStatementWarning")
              .remove();
          }
        });
      });
    },

    generalFormValidation: function() {
      const _ = this;
      const $generalForm = $("[data-form]:not(.redirect-form)");

      $generalForm.each(function() {
        const $form = $(this);

        const formName = $(this).find('[name="Form_Name"]').val();
        const formID = $(this).find('[name="Form_ID"]').val();
        const currentPage = $(this).find('[name="Current_Page"]').val();
        const refererPage = $(this).find('[name="Referer"]').val();
        const refererInfo = $(this).find('[name="Referer_Info"]').val();
        const IPAddress = $(this).find('[name="IP_Address"]').val();

        let aRequiredFields = [];

        $form.find("[data-required]").each(function() {
          let fieldName = $(this).attr("name");
          if (fieldName.length) {
            aRequiredFields.push(fieldName);
          }
        });

        $form.find(".form__label-required").each(function() {
          const $req = $(this);
          const $label = $req.parent("label");
          const fieldId = $label.attr("for");
          const $field = $('[id="' + fieldId + '"');
          let fieldName = $field.attr("name");
          if (fieldName.length) {
            aRequiredFields.push(fieldName);
          }
        });

        aRequiredFields.forEach(function(name, index) {
          if (name.includes("Phone") || name.includes("phone")) {
            aRequiredFields[index] = name + "{phone}";
          }
          if (name.includes("Email") || name.includes("email")) {
            aRequiredFields[index] = name + "{email}";
          }
        });

        const redirectForm = forms.redirectForm.replace(
          'data-form=""',
          'data-form="' + formID + '"',
        );
        if (
          $generalForm.length &&
          !$('form.redirect-form[data-form="' + formID + '"]').length
        ) {
          $("body").append(redirectForm);
        }

        const $redirectForm = $('.redirect-form[data-form="' + formID + '"]');
        $redirectForm.find('[name="id"]').val(formID);
        $redirectForm.find('[name="page"]').val(currentPage);
        $redirectForm.find('[name="ip_address"]').val(IPAddress);
        $redirectForm.find('[name="referer"]').val(refererPage);
        $redirectForm.find('[name="referer_info"]').val(refererInfo);

        $form.formulate({
          require: aRequiredFields.join(","),
          errorClass: "error",
          errorParent: true,
          hideFormOnSubmit: false,
          inlineMsg: true,
          inlineMsgClass: "form__inline-error",
          fireOnSubmit: function(data, form) {
            $(".form__message", $(form)).remove();
          },
          fireOnSuccess: function(data, form) {
            if (typeof JonahTracking != "undefined") {
              JonahTracking.event.formSubmit($(form).attr("id"));
            }

            event_tracker("Form Submission", "form_success", formName);
            $redirectForm.submit();
          },
          fireOnError: function(data, form) {
            if (data !== false) {
              let response;
              try {
                response = JSON.parse(data);
                response = response.message;
              } catch (e) {
                response = data;
              }
              const $message =
                '<p class="form__message bg-danger">' + response + "</p>";
              $(form).prepend($message);
            }
            if ($(".error :input", $(form)).length) {
              $(".error :input", $(form))[0].focus();
            }
          },
        });
      });
    },

    formModal: function() {
      const _ = this;
      let formMarkup;

      _.$formLink.each(function() {
        const $link = $(this);
        const href = $link.attr("href");
        let $modal = undefined;
        $link.click(function(event) {
          event.preventDefault();
          if (!$('.modal[data-dynamic="' + href + '"]').length) {
            $modal = $(dynamicModal.innerHTML);
            $.get(href, function(data) {
              $modal.find(".modal__body").html(data);
              $modal.attr("data-dynamic", href);
              $("body").append($modal);
              modal.open($modal);
              _.infieldLabels();
              _.generalFormValidation();
            });
          }
          else {
            $modal = $('.modal[data-dynamic="' + href + '"]');
            modal.open($modal);
          }
        });
      });
    },

    surveyForm: function() {
      var $form = $('[data-form="survey"]');

      if (typeof $form != "undefined" && $form.length) {
        var $checkbox = $('[type="checkbox"]');
        var $experience = $('[name="Experience"]');
        var $experienceDiv = $("[data-form-experience]");
        var $experinceFail = $(
          '[name="Experience: Failures[]"][value="Other"]',
        );
        var $experinceFailOther = $("#experienceFailOther");
        var $firstTime = $('[name="First_Time"]');
        var $firstTimeInfo = $("#firstTimeInfo");

        $checkbox.on("change", function() {
          var regex = /$|\\|\/|\s|\[|\]|_|\^/gi;
          var name = $(this).attr("name").replaceAll(regex, "");
          var value = $(this).val().replaceAll(regex, "");
          var target = name + value;
          var $target = $("#" + target);

          if ($target.length) {
            if ($(this).prop("checked")) {
              $target.show().find("input").focus();
            }
            else {
              $target.hide();
            }
          }
        });

        $experience.on("change", function() {
          var value = $(this).val();
          $experience.parent().css("opacity", ".4");
          $(this).parent().css("opacity", "1");

          switch (value) {
            case "Love":
              $experienceDiv.hide();
              $experienceDiv
                .filter('[data-form-experience="great"]')
                .show()
                .find("input")
                .focus();
              break;
            case "Good":
              $experienceDiv.hide();
              $experienceDiv
                .filter('[data-form-experience="great"]')
                .show()
                .find("input")
                .focus();
              $experienceDiv.filter('[data-form-experience="improve"]').show();
              break;
            case "Eh":
              $experienceDiv.hide();
              $experienceDiv
                .filter('[data-form-experience="improve"]')
                .show()
                .find("input")
                .focus();
              break;
            case "Not Good":
              $experienceDiv.hide();
              $experienceDiv
                .filter('[data-form-experience="improve"]')
                .show()
                .find("input")
                .focus();
              break;
            case "Horrible":
              $experienceDiv.hide();
              $experienceDiv.filter('[data-form-experience="fail"]').show();
              $experienceDiv.filter('[data-form-experience="improve"]').show();
              break;
            default:
              $experienceDiv.hide();
              break;
          }
        });

        $experinceFail.on("change", function() {
          if ($(this).prop("checked")) {
            $experinceFailOther.show().find("input").focus();
          }
          else {
            $experinceFailOther.hide();
          }
        });

        $firstTime.on("change", function() {
          if ($(this).val() === "Yes") {
            $firstTimeInfo.show();
          }
          else {
            $firstTimeInfo.hide();
          }
        });
      }
    },

    cmsForm: function() {
      const $form = $('form[name^="dynoForm"]');
      $form.each(function() {
        const $this = $(this);

        const formID = $this.attr("name").replace("dynoForm", "");
        const currentPage = location.origin + location.pathname;
        const refererPage = $("#form" + formID + "_Referer").data("value");
        const refererInfo = $("#form" + formID + "_Referer_Info").data("value");
        const IPAddress = $("#form" + formID + "_IP_Address").data("value");

        const $required = $this.find(".form_row.required");
        let requiredFields = [];
        $required.each(function() {
          const $requiredRow = $(this);
          const $requiredField = $requiredRow
            .find(".form_right_column")
            .children()
            .first();
          requiredFields.push($requiredField.attr("name"));
        });

        const redirectForm = forms.redirectForm.replace(
          'data-form=""',
          'data-form="' + formID + '"',
        );
        if (!$('form.redirect-form[data-form="' + formID + '"]').length) {
          $("body").append(redirectForm);
        }

        const $redirectForm = $('.redirect-form[data-form="' + formID + '"]');

        $redirectForm.find('[name="id"]').val(formID);
        $redirectForm.find('[name="page"]').val(currentPage);
        $redirectForm.find('[name="referer"]').val(refererPage);
        $redirectForm.find('[name="referer_info"]').val(refererInfo);
        $redirectForm.find('[name="ip_address"]').val(IPAddress);
      });
    },

    applyForm: function() {
      if (!this.forms.apply.length) {
        return;
      }

      var jobHearAboutUs = document.getElementById('jobHearAboutUs');
      var otherOptionWrap = document.getElementById('otherOptionWrap');
      var jobHearAboutUsOther = document.getElementById('jobHearAboutUsOther');
      var form = document.getElementById('form');
      jobHearAboutUs.addEventListener('change', () => {
        if (jobHearAboutUs.value === 'other') {
          otherOptionWrap.style.display = 'block';
          jobHearAboutUsOther.focus();
        }
        else {
          otherOptionWrap.style.display = 'none';
        }
      });

      var jobLocation = document.getElementById('jobLocation');
      var jobLocationWarning = document.getElementById('jobLocationWarning');
      jobLocation.addEventListener('change', () => {
        if (jobLocation.value === 'No') {
          jobLocationWarning.style.display = 'block';
        }
        else {
          jobLocationWarning.style.display = 'none';
        }
      });

      var checkboxes = document.querySelectorAll('.form__checkbox');
      var checkedCount = 0;

      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => {
          if (checkbox.checked) {
            checkedCount++;
            if (checkedCount > 2) {
              checkbox.checked = false;
              checkedCount--;
            }
          }
          else {
            checkedCount--;
          }

          checkboxes.forEach(cb => {
            if (!cb.checked) {
              cb.parentElement.style.opacity = checkedCount >= 2 ? "0.5" : "1";
            }
          });
        });
      });
    },

    ready: function() {
      this.dom();
      this.checkbox();
      this.clearInputs();
      this.datePicker();
      this.fileTrigger();
      this.filePreview();
      this.formValidation();
      this.generalFormValidation();
      this.formModal();
      this.surveyForm();
      this.cmsForm();
      this.applyForm();
    },
  };

  $(function() {
    forms.ready();
  });

  $(window).on("load", function() {
    forms.infieldLabels();
  });

})(jQuery);
